import { StrictMode } from 'react'
import { Provider } from 'react-redux'
import store from 'store/store'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { isDevelopment } from './helpers/helperFunctions'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element not found')
}
const root = createRoot(container)

const Application = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

// TODO(UTT-252): Investigate why StrictMode is active on non-development builds without this condition
root.render(
  isDevelopment() ? (
    <StrictMode>
      <Application />
    </StrictMode>
  ) : (
    <Application />
  )
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
